import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const AttrShapekeyIcon = React.memo<IconProps>(({ 
  className = '',
  size = 24,
  color = 'currentColor',
  onClick,
  strokeWidth
}) => (
  <BaseIcon
    className={className}
    size={size}
    color={color}
    onClick={onClick}
    viewBox="0 0 24 24"
    strokeWidth={strokeWidth}
  >
    <path d="M23.71 10.29L13.71 0.29C13.52 0.1 13.27 0 13 0H1C0.45 0 0 0.45 0 1V13C0 13.27 0.11 13.52 0.29 13.71L10.29 23.71C10.47 23.89 10.72 24 11 24H23C23.55 24 24 23.55 24 23V11C24 10.72 23.89 10.47 23.71 10.29ZM2 2H12.59L20.59 10H11C10.45 10 10 10.45 10 11V20.59L2 12.59V2ZM22 22H12V12H22V22Z" fill={color}/>
  </BaseIcon>
));

AttrShapekeyIcon.displayName = 'AttrShapekeyIcon';
